/* tslint:disable */
import * as Types from '../../../../../../graphql-api/baskets-api-interfaces';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type SearchUserBasketsQueryVariables = Types.Exact<{
  num?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  start?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  basketsAmount?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  orderReferenceNumber?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type SearchUserBasketsQuery = { searchUserBaskets?: { total?: number | null, items?: Array<{ user?: { id: string, displayName?: string | null, profilePictureUrl?: string | null } | null, baskets?: Array<{ id: string, orderReferenceNumber: string, clientReferenceNumber?: string | null, createdTime: any, status?: string | null, totalQuantity: number, totalValueByCurrency?: any | null, netTotalValueByCurrency?: any | null, reviewStatus?: Types.ReviewStatus | null, basketAccounts?: Array<{ externalId?: string | null, accountId: string, address?: { name?: string | null, accountId: string, addressId: string } | null } | null> | null } | null> | null } | null> | null } | null };

export const SearchUserBasketsDocument = gql`
    query SearchUserBaskets($num: Int, $start: Int, $basketsAmount: Int, $orderReferenceNumber: String) {
  searchUserBaskets(
    num: $num
    start: $start
    basketsAmount: $basketsAmount
    orderReferenceNumber: $orderReferenceNumber
  ) {
    total
    items {
      user {
        id
        displayName
        profilePictureUrl
      }
      baskets {
        id
        orderReferenceNumber
        clientReferenceNumber
        createdTime
        status
        basketAccounts {
          externalId
          accountId
          address {
            name
            accountId
            addressId
          }
        }
        totalQuantity
        totalValueByCurrency
        netTotalValueByCurrency
        reviewStatus
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchUserBasketsGQL extends Apollo.Query<SearchUserBasketsQuery, SearchUserBasketsQueryVariables> {
    document = SearchUserBasketsDocument;
    client = 'baskets';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }